<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';
  import type { IMonitoringConfig } from '$provider/lib/apis/interfaces/IResponse';
  import { data } from '$provider/lib/datas';

  interface Props {
    config: IMonitoringConfig;
  }

  let { config }: Props = $props();

  let show = $derived(config.monitoringInterval === data.MonitoringInterval.Continuous);
</script>

{#if config}
  <div class="label">Monitoring:</div>
  <div data-cy="metaInfo-monitor-status" class="status">
    {config.enableMonitoring ? 'On' : 'Off'}
  </div>
  {#if config.enableMonitoring}
    <div data-cy="metaInfo-monitor-frequency" class="frequency">
      (
      {config.monitoringInterval}
      <span class="continuous-icon" class:show>
        <Icon value="icon-continuous-monitor grey" size="14px" fontSize="14px" />
      </span>
      )
    </div>
  {/if}
{/if}

<style>
  .label,
  .status {
    margin-right: 4px;
  }
  .continuous-icon {
    display: none;
  }
  .continuous-icon.show {
    display: initial;
  }
</style>
